import { observable, makeObservable } from 'mobx';

import { createModelSchema, primitive, object } from 'serializr';

import { Position } from '@vromo/models';
import { Account } from '@vromo/models';
import { User } from '@vromo/models';
import { Group } from '@vromo/models';

import { optional } from '@vromo/models';

export class Role {
    id: number | null = null;
    created: number | null = null;

    /** current group to which the user is using */
    group: Group | null = null;
    position: Position | null = null;
    account: Account | null = null;
    user: User | null = null;

    constructor() {
        makeObservable(this, {
            group: observable,
            position: observable,
            account: observable,
            user: observable
        });
    }
}

createModelSchema(Role, {
    id: optional(primitive()),
    created: optional(primitive()),

    group: optional(object(Group)),
    position: optional(object(Position)),
    account: optional(object(Account)),
    user: optional(object(User))
});
